import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Grid, Typography, Container, Box } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { allPageData } from '../../../data/pageData';

const styles = (theme) => ({
  pageContainer: {
    backgroundColor: "#f8f9fa",
    minHeight: "100vh",
    paddingTop: theme.spacing(12),
    paddingBottom: theme.spacing(8),
  },
  contentContainer: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: theme.spacing(0, 4),
  },
  pageTitle: {
    fontSize: "36px",
    fontWeight: 700,
    color: "#1e3a5f",
    marginBottom: theme.spacing(2),
    fontFamily: '"Georgia", serif',
  },
  category: {
    fontSize: "14px",
    letterSpacing: "2px",
    textTransform: "uppercase",
    color: "white",
    background: "#d4145a",
    display: "inline-block",
    padding: "6px 16px",
    marginBottom: theme.spacing(3),
    fontFamily: '"Segoe UI", sans-serif',
    fontWeight: 600,
  },
  section: {
    marginBottom: theme.spacing(6),
  },
  content: {
    fontSize: "16px",
    lineHeight: 1.8,
    color: "#444",
    fontFamily: '"Segoe UI", sans-serif',
    "& p": {
      marginBottom: theme.spacing(2),
    },
  },
  breadcrumb: {
    marginBottom: theme.spacing(4),
    color: "#666",
    fontSize: "14px",
  },
  breadcrumbLink: {
    color: "#1e3a5f",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
    marginRight: "8px",
  },
  keyPointsSection: {
    background: "white",
    padding: theme.spacing(4),
    borderLeft: "4px solid #d4145a",
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  keyPointTitle: {
    fontSize: "20px",
    fontWeight: 600,
    color: "#1a1a1a",
    marginBottom: theme.spacing(2),
    fontFamily: '"Georgia", serif',
  },
  keyPointList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  keyPointItem: {
    position: "relative",
    paddingLeft: "20px",
    marginBottom: "10px",
    fontSize: "15px",
    lineHeight: 1.6,
    "&:before": {
      content: '"•"',
      color: "#d4145a",
      fontWeight: "bold",
      position: "absolute",
      left: 0,
    },
  },
  quoteSection: {
    fontStyle: "italic",
    borderLeft: "3px solid #1e3a5f",
    paddingLeft: theme.spacing(3),
    margin: theme.spacing(4, 0),
    color: "#555",
  },
});

function SuccessStory(props) {
  const { classes, storyData } = props;
  const location = useLocation();
  const navigate = useNavigate();
  
  // Get story data from either props or URL path
  const getStoryData = () => {
    // If custom data is provided via props, use that
    if (storyData) return storyData;
    
    // Otherwise derive from URL path
    const pathName = location.pathname;
    const pathSegments = pathName.split('/').filter(Boolean);
    
    // TODO: Replace with actual data lookup from a success stories data store
    // This is a placeholder, in a real implementation you would look up from a proper data source
    return {
      title: "Default Success Story",
      category: "General",
      content: "This is a default success story content. Please provide actual story data.",
      keyPoints: [
        "Key point one",
        "Key point two",
        "Key point three"
      ],
      quote: "A default quote for this success story.",
      relatedStories: []
    };
  };
  
  const story = getStoryData();
  
  return (
    <div className={classes.pageContainer}>
      <Container maxWidth="lg" className={classes.contentContainer}>
        <div className={classes.breadcrumb}>
          <a href="/" className={classes.breadcrumbLink}>Home</a> &gt; 
          <a href="/#cases" className={classes.breadcrumbLink}>Success Stories</a> &gt; 
          {story.title}
        </div>
        
        <div className={classes.category}>{story.category}</div>
        
        <Typography variant="h1" className={classes.pageTitle}>
          {story.title}
        </Typography>
        
        <div className={classes.section}>
          <div className={classes.content}>
            <p>{story.content}</p>
          </div>
          
          {story.keyPoints && story.keyPoints.length > 0 && (
            <div className={classes.keyPointsSection}>
              <Typography className={classes.keyPointTitle}>
                Key Highlights
              </Typography>
              <ul className={classes.keyPointList}>
                {story.keyPoints.map((point, index) => (
                  <li key={index} className={classes.keyPointItem}>
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          )}
          
          {story.quote && (
            <div className={classes.quoteSection}>
              <Typography>
                "{story.quote}"
              </Typography>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
}

export default withStyles(styles)(SuccessStory);